import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Fieldset } from 'primereact/fieldset'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  Btn,
  Cnpj,
  CustomCheckbox,
  CustomDropdown,
  CustomPanel,
  Loading,
  PageHeader,
  CustomDataTableHeader,
  DateTime,
  SectionTitle,
  Periodo,
  BadgeStatusEntrega,
  CustomCard,
} from '../../../../components'
import { showMessageBox } from '../../../../store/actions/system.actions'
import useTransferenciaAssocEntrega from './TransferenciaAssocEntregaState'
import ModalDisponivel from '../CargasParadasTransferencia/ModalDisponivel/ModalDisponivel'

export default connect()(withRouter(TransferenciaAssocEntrega))

function TransferenciaAssocEntrega({ history, dispatch }) {
  const { transferencia, selectedTp } = history.location.state
  const { state, localDispatch } = useTransferenciaAssocEntrega(transferencia, selectedTp)
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    state.errorMessage &&
      dispatch(showMessageBox(null, state.errorMessage)) &&
      localDispatch.resetMessages()
  }, [state.errorMessage])

  useEffect(() => {
    state.successMessage &&
      dispatch(showMessageBox(state.successMessage, null)) &&
      localDispatch.resetMessages()
  }, [state.successMessage])

  useEffect(() => {
    selectedTp &&
      selectedTp > 0 &&
      localDispatch.fetchDeliveriesToBeTransferred(state.pInicial, state.pFinal)
  }, [selectedTp])

  // Components
  return (
    <div>
      <PageHeader>
        <span>Transferência das Entregas</span>
        <strong> - {transferencia ? transferencia.transfer_name : ''} </strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {state.isContentLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <div className="p-grid">
              <div className="p-col-12">
                <SectionTitle title="Listagem de Carga Parada" />
              </div>
              <div className="p-col-4">
                <Periodo
                  periodoInicial={state.pInicial}
                  periodoFinal={state.pFinal}
                  onPesquisar={(pInicial, pFinal) => {
                    selectedTp &&
                      selectedTp > 0 &&
                      localDispatch.fetchDeliveriesToBeTransferred(pInicial, pFinal)
                  }}
                />
              </div>
              <div className="p-col-12">
                <Fieldset legend="Filtro" toggleable collapsed={true} className="p-col-12">
                  <div className="p-grid">
                    <div className="p-col-3">
                      <CustomDropdown
                        optionLabel="name"
                        options={state.empresas}
                        value={state.empresaSelecionada}
                        label="Empresa :"
                        onChange={value =>
                          localDispatch.onFormDataChange('empresaSelecionada', value)
                        }
                      />
                    </div>
                    <div className="p-col-3">
                      <CustomDropdown
                        optionLabel="name"
                        options={state.tps}
                        value={state.tpSelecionado}
                        label="Operador Logístico :"
                        onChange={value => localDispatch.onFormDataChange('tpSelecionado', value)}
                      />
                    </div>
                    <div className="p-col-3">
                      <CustomDropdown
                        optionLabel="name"
                        options={state.ciclos}
                        value={state.cicloSelecionado}
                        label="Ciclo de Entrega :"
                        onChange={value =>
                          localDispatch.onFormDataChange('cicloSelecionado', value)
                        }
                      />
                    </div>
                    <div className="p-col-2" style={{ paddingTop: 32 }}>
                      <Btn onClick={localDispatch.limpar}>Limpar</Btn>
                    </div>
                  </div>
                </Fieldset>
              </div>
              <div className="p-col-2" style={{ marginTop: 16 }}>
                <CustomCheckbox
                  disabled={!transferencia || transferencia.status === 'Transferida'}
                  checked={state.selecionarTodos}
                  onChange={value => localDispatch.onFormDataChange('selecionarTodos', value)}
                >
                  Selecionar Todos
                </CustomCheckbox>
              </div>
              <div className="p-col-10" style={{ marginTop: 8 }}>
                <Btn
                  onClick={() => localDispatch.salvar(state.entregas, state.pInicial, state.pFinal)}
                  isLoading={state.isBtnLoading}
                  disabled={
                    !transferencia ||
                    transferencia.status === 'Transferida' ||
                    transferencia.status === 'Cancelada'
                  }
                >
                  Salvar
                </Btn>
              </div>
              <div className="p-col-12" style={{ marginTop: 16 }}>
                <div className="p-grid">
                  <div className="p-col-3">
                    <CustomCard
                      title="Qte Identificadores"
                      valueStyle={{
                        fontSize: '1.1rem',
                        color: '#14B0BF',
                        fontWeight: 600,
                      }}
                    >
                      {state.qteIdentifiers.toLocaleString()}
                    </CustomCard>
                  </div>
                  <div className="p-col-3">
                    <CustomCard
                      title="Qte Skus"
                      valueStyle={{
                        fontSize: '1.1rem',
                        color: '#14B0BF',
                        fontWeight: 600,
                      }}
                    >
                      {state.qteSkus.toLocaleString()}
                    </CustomCard>
                  </div>
                  <div className="p-col-3">
                    <CustomCard
                      title="Peso Total"
                      valueStyle={{
                        fontSize: '1.1rem',
                        color: '#14B0BF',
                        fontWeight: 600,
                      }}
                    >
                      {state.pesoTotal.toLocaleString()}
                    </CustomCard>
                  </div>
                  <div className="p-col-3"></div>
                </div>
              </div>
              <div className="p-col-12" style={{ marginTop: 8 }}>
                <DataTable
                  paginator={true}
                  rows={20}
                  globalFilter={globalFilter}
                  header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
                  value={state.entregas}
                >
                  <Column
                    field="selected"
                    style={tableCellCentered(50)}
                    body={entrega => (
                      <CustomCheckbox
                        disabled={!transferencia || transferencia.status === 'Transferida'}
                        checked={entrega.selected === 1}
                        onChange={() => localDispatch.checkRow(entrega)}
                      />
                    )}
                  />
                  <Column
                    field="created_at"
                    header="Criada Em"
                    body={entrega => <DateTime>{entrega.created_at}</DateTime>}
                    style={tableCellCentered(100)}
                  />
                  <Column
                    field="razao_social"
                    header="Razão Social"
                    body={entrega => (
                      <>
                        <div>{entrega.razao_social}</div>
                        <small>
                          <Cnpj>{entrega.cnpj}</Cnpj>
                        </small>
                      </>
                    )}
                  />
                  <Column field="city" header="Cidade" />
                  <Column
                    field="identifier"
                    header="Identificador"
                    style={tableCellCentered(120)}
                  />
                  <Column field="cycle_id" header="Ciclo" style={tableCellCentered(100)} />
                  <Column field="company_name" header="Empresa" style={tableCellCentered(120)} />
                  <Column field="tp_name" header="Destino" style={tableCellCentered(200)} />
                  <Column field="qte_sku" header="Qte. Volumes" style={tableCellCentered(110)} />
                  <Column field="weight" header="Peso" style={tableCellCentered(110)} />
                  <Column
                    field="available_to_transfer"
                    header="Disponível"
                    style={tableCellCentered(100)}
                    body={entrega => {
                      const isAvailable = entrega.available_to_transfer === 1 || entrega.available_to_transfer === true
                      const isBlocked = transferencia && transferencia.status === 'Transferida'
                      return (
                        <span
                          style={{
                            backgroundColor: isAvailable ? '#14b0bf' : '#dc3545',
                            color: '#fff',
                            padding: '3px 10px',
                            borderRadius: 12,
                            cursor: isBlocked ? 'not-allowed' : 'pointer',
                            fontSize: '0.8rem',
                            whiteSpace: 'nowrap',
                            opacity: isBlocked ? 0.6 : 1,
                          }}
                          onClick={() => !isBlocked && localDispatch.openModalDisponivel(entrega)}
                        >
                          {isAvailable ? 'Sim' : 'Não'}
                        </span>
                      )
                    }}
                  />
                  <Column
                    field="status"
                    header="Status"
                    style={tableCellCentered(100)}
                    body={entrega => <BadgeStatusEntrega status={entrega.status} />}
                  />
                </DataTable>
              </div>
            </div>
          )}
        </CustomPanel>
      </div>
      <ModalDisponivel
        show={state.modalDisponivel.show}
        data={state.modalDisponivel.data}
        onClose={localDispatch.closeModalDisponivel}
        isBtnLoading={state.isBtnLoading}
        onSave={(delivery_id, available_to_transfer, reason) =>
          localDispatch.saveAvailableToTransfer(delivery_id, available_to_transfer, reason)
        }
      />
    </div>
  )
}
